import { render, staticRenderFns } from "./SafeValiate.vue?vue&type=template&id=dcda4764"
import script from "./SafeValiate.vue?vue&type=script&lang=js"
export * from "./SafeValiate.vue?vue&type=script&lang=js"
import style0 from "./SafeValiate.vue?vue&type=style&index=0&id=dcda4764&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports